import axios from 'axios';
import React from 'react';
import { ApiConnectionString } from '../../../constants/ApiConntection';
import { useAuthContext } from '../../../hooks/useAuthContext';

export default function OfferModal({ offer, onClose }) {

  const { user } = useAuthContext();

  const activateCheckout = async () => {
    try {
      const checkoutResponse = await axios.post(
        `${ApiConnectionString}/api/checkout/${offer.websiteId}/${offer.priceId}`,
        {},
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      const url =
        typeof checkoutResponse.data === 'string'
          ? checkoutResponse.data
          : checkoutResponse.data?.url || checkoutResponse.data?.Url;

      if (url) {
        window.location.href = url;
      } else {
        console.log('No url found in response');
      }
    } catch (error) {
      console.log('Checkout error:', error);
    }
  };

  if (!offer) return null;

  return (
    <>
      <div className="modal-backdrop fade show"></div>

      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title brand-purple">{offer.productName}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            <div className="modal-body">

              <h4 className="text-center mb-3 brand-dark-purple">
                Unlock Your Website
              </h4>
              <p className="text-center mb-4 brand-dark-purple">
                Professional website designed to help you grow.
              </p>

              <div className="p-3 custom-card-light rounded mb-3">
                <p className="mb-1 brand-dark-purple"><strong>What you get:</strong></p>
                <ul className="mb-0">
                  <li>Your own website hosted</li>
                  <li>Mobile friendly design</li>
                  <li>Monthly updates</li>
                </ul>
              </div>

              <div className="p-3 custom-card rounded mb-3">
                <p className="mb-2 brand-dark-purple">
                  <strong>Plan:</strong> {offer.productName}
                </p>
                <p className="mb-2 brand-dark-purple">
                  <strong>Price:</strong> {offer.displayPrice}
                </p>
                <p className="mb-0 brand-dark-purple">
                  {offer.productDescription}
                </p>
              </div>

              {offer.previewUrl && (
                <a
                  href={offer.previewUrl}
                  target="blank"
                  rel="noopener noreferrer"
                  className="btn btn-secondary w-100 mb-3"
                >
                  Preview Website
                </a>
              )}

              <div onClick={activateCheckout} className="alert brand-purple-inline text-center mb-0 pointer">
                Start now and launch your website today.
              </div>

            </div>

            <div className="modal-footer">
              <button className="btn brand-purple-outline" onClick={onClose}>
                Not Now
              </button>
              <button className="btn brand-purple-inline" onClick={activateCheckout}>
                Create My Website
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
